const isDev = process.env.NODE_ENV === 'development';

// TODO: we should have 'es' and 'it' but right now we dont have translation yet
const supportedLocales = ['en-GB'] as const;
const devSupportedLocales = ['en-GB', 'zz'] as const;

export const SUPPORTED_LOCALES = isDev ? devSupportedLocales : supportedLocales;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];
